/* @generated */

// ../src/metadata/metadata.tsx
import * as React2 from "react";
import classNames from "classnames";

// ../src/metadata/metadata.css.ts
var hasBullet = "dig-1gvg1ar3_22-5-0";
var root = "dig-1gvg1ar2_22-5-0";
var sizeMedium = "dig-1gvg1ar6_22-5-0";
var sizeSmall = "dig-1gvg1ar5_22-5-0";

// ../src/metadata/context.ts
import * as React from "react";
var defaultMetadataContext = {
  withDividers: "bullet",
  size: "small"
};
var MetadataContext = React.createContext(defaultMetadataContext);

// ../src/metadata/metadata.tsx
var Metadata = ({
  children,
  className,
  size: _size,
  withDividers: _withDividers,
  ...props
}) => {
  const ctxProps = React2.useContext(MetadataContext);
  const size = _size != null ? _size : ctxProps.size;
  const withDividers = _withDividers != null ? _withDividers : ctxProps.withDividers;
  return /* @__PURE__ */ React2.createElement(
    MetadataContext.Provider,
    {
      value: {
        withDividers,
        size
      }
    },
    /* @__PURE__ */ React2.createElement(
      "span",
      {
        role: "list",
        className: classNames(root, className, {
          [hasBullet]: withDividers === "bullet",
          [sizeSmall]: size === "small",
          [sizeMedium]: size === "medium"
        }),
        ...props
      },
      children
    )
  );
};

// ../src/metadata/item.tsx
import * as React3 from "react";
import classNames2 from "classnames";

// ../src/metadata/item.css.ts
var hasBullet2 = "dig-1chkwpz5_22-5-0";
var itemRoot = "dig-1chkwpz3_22-5-0";
var itemRootFocusVisible = "dig-1chkwpz4_22-5-0";
var sizeMedium2 = "dig-1chkwpz7_22-5-0";
var sizeSmall2 = "dig-1chkwpz6_22-5-0";

// ../src/metadata/item.tsx
var _Item = ({
  children,
  className,
  withDividers: _withDividers,
  ...props
}) => {
  const { withDividers: withDividersFromContext, size } = React3.useContext(MetadataContext);
  const withDividers = _withDividers || withDividersFromContext;
  return /* @__PURE__ */ React3.createElement(
    "span",
    {
      role: "listitem",
      className: classNames2(itemRoot, itemRootFocusVisible, className, {
        [hasBullet2]: withDividers === "bullet",
        [sizeSmall2]: size === "small",
        [sizeMedium2]: size === "medium"
      }),
      ...props
    },
    children
  );
};

// ../src/metadata/avatar.tsx
import * as React4 from "react";
import { Avatar } from "@dropbox/dig-components/avatar";
import classNames3 from "classnames";

// ../src/metadata/avatar.css.ts
var avatarRoot = "dig-s81hzm0_22-5-0";
var sizeMedium3 = "dig-s81hzm1_22-5-0";

// ../src/metadata/avatar.tsx
var _Avatar = ({ className, ...props }) => {
  const { size } = React4.useContext(MetadataContext);
  const cls = classNames3(className, avatarRoot, {
    [sizeMedium3]: size === "medium"
  });
  return /* @__PURE__ */ React4.createElement(Avatar, { ...props, className: cls, size: size === "small" ? "xsmall" : "small" });
};

// ../src/metadata/ui-icon.tsx
import * as React5 from "react";
import { UIIcon } from "@dropbox/dig-icons";
import classNames4 from "classnames";

// ../src/metadata/ui-icon.css.ts
var iconMedium = "dig-1j0056m1_22-5-0";
var uiIconRoot = "dig-1j0056m0_22-5-0";

// ../src/metadata/ui-icon.tsx
var _UIIcon = ({ className, ...props }) => {
  const { size } = React5.useContext(MetadataContext);
  const cls = classNames4(className, uiIconRoot, {
    [iconMedium]: size === "medium"
  });
  return /* @__PURE__ */ React5.createElement(UIIcon, { ...props, className: cls, size: "small" });
};

// ../src/metadata/arbitrary-icon.tsx
import * as React6 from "react";
import classNames5 from "classnames";

// ../src/metadata/arbitrary-icon.css.ts
var iconMedium2 = "dig-unay0n2_22-5-0";
var iconRoot = "dig-unay0n0_22-5-0";
var iconSmall = "dig-unay0n1_22-5-0";

// ../src/metadata/arbitrary-icon.tsx
var _ArbitraryIcon = ({ className, src, ...props }) => {
  const { size } = React6.useContext(MetadataContext);
  const cls = classNames5(className, iconRoot, {
    [iconSmall]: size === "small",
    [iconMedium2]: size === "medium"
  });
  return /* @__PURE__ */ React6.createElement("span", { ...props, className: cls }, src);
};

// ../src/metadata/label.tsx
import * as React7 from "react";
import { atoms } from "@dropbox/dig-foundations";
import classNames6 from "classnames";

// ../src/metadata/label.css.ts
var isInteractive = "dig-mrhnna2_22-5-0";
var labelRoot = "dig-mrhnna0_22-5-0";
var overflowEllipsis = "dig-mrhnna1_22-5-0";

// ../src/metadata/label.tsx
import { useResizeObserver } from "@react-hookz/web";
import { Tooltip } from "@dropbox/dig-components/tooltips";
var focusStyling = atoms({
  outline: "none",
  color: { active: "Text Base" }
});
var _Label = ({
  children,
  className,
  as,
  tooltipControlProps,
  onOverflow,
  ...props
}) => {
  const ref = React7.useRef(null);
  const [isOverflowing, setIsOverflowing] = React7.useState(false);
  const [isFocused, setIsFocused] = React7.useState(false);
  useResizeObserver(ref, (entry) => {
    const { target } = entry;
    if (target instanceof HTMLElement) {
      const isOverflowing2 = target.offsetWidth < target.scrollWidth;
      setIsOverflowing(isOverflowing2);
      if (onOverflow) onOverflow({ target, isOverflowing: isOverflowing2 });
    }
  });
  const handleIsHovered = () => {
    if (!isOverflowing) {
      return;
    }
    setIsFocused(true);
  };
  const handleIsNotHovered = () => {
    if (!isOverflowing) {
      return;
    }
    setIsFocused(false);
  };
  const PolymorphicComponent = as || "span";
  const isInteractive2 = as === "a" || as === "button";
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, isOverflowing && /* @__PURE__ */ React7.createElement(
    Tooltip.Control,
    {
      triggerRef: ref,
      placement: "top",
      isPortaled: true,
      open: isFocused,
      auto: true,
      shouldReturnFocus: false,
      openDelay: 250,
      variant: "basic",
      ...tooltipControlProps
    },
    children
  ), /* @__PURE__ */ React7.createElement(
    PolymorphicComponent,
    {
      ...props,
      onPointerEnter: () => {
        handleIsHovered();
        if (props.onPointerEnter) props.onPointerEnter();
      },
      onPointerLeave: () => {
        handleIsNotHovered();
        if (props.onPointerLeave) props.onPointerLeave();
      },
      onFocus: () => {
        handleIsHovered();
        if (props.onFocus) props.onFocus();
      },
      onBlur: () => {
        handleIsNotHovered();
        if (props.onBlur) props.onBlur();
      },
      className: classNames6(labelRoot, className, {
        [isInteractive]: isInteractive2,
        [focusStyling]: isInteractive2
      })
    },
    /* @__PURE__ */ React7.createElement("span", { ref, className: overflowEllipsis }, children)
  ));
};

// ../src/metadata/index.ts
var Metadata2 = Object.assign(Metadata, {
  /**
   * This component acts as a container for any content within the `Metadata` component.
   */
  Item: _Item,
  /**
   * This is a wrapper around the DIG `Avatar` component that handles the size prop internally.
   */
  Avatar: _Avatar,
  /**
   * This is a wrapper around the DIG `UIIcon` component that handles the size prop internally.
   */
  UIIcon: _UIIcon,
  /**
   * This exists to attempt to apply sizing to a generic svg or img icon passed into the `src` prop.
   */
  ArbitraryIcon: _ArbitraryIcon,
  /**
   * The `Label` of the `Metadata.Item` component.
   * Please use this for any text content within the `Metadata.Item` component.
   */
  Label: _Label
});
export {
  Metadata2 as Metadata,
  MetadataContext
};
